import * as _ from 'lodash-es';

// NOTE:  Dependencies copied from core.user.service.ts
// TODO Refactor DRY with core.user.service.ts

// TODO Re-add translation
export const nobody = {
    id: 100,
    unixName: 'None',
    firstName: "Nobody",
    lastName: ' '
};


export function getAvatarUrl(user) {
    var unixName = _.get(user, 'unixName', user);
    if (typeof unixName !== 'string' || unixName == '') {
        unixName = '100';
    }
    const ret = '/api/user/' + unixName + '/avatar';
    return ret;
};

export function isNobody(u) {
    return _.get(u, 'id', '') == nobody.id;
}

export function getFullName(userBasic: any): string {
    var ret = '';

    // TODO Re-add translation
    if (isNobody(userBasic)) {
        return "Nobody";
    }

    if (userBasic) {
        var firstname = _.get(userBasic, 'firstname', '');
        var lastname = _.get(userBasic, 'lastname', '');

        if (firstname == null || firstname == 'null') {
            firstname = '';
        }

        if (lastname == null || lastname == 'null') {
            lastname = '';
        }

        ret = firstname + ' ' + lastname;

        //This is a special property used for tracker item edit
        //for the case of assignees that are former members
        //if (_.get(userBasic, '_former', false) === true) {
        //    ret += ' (Former Member)';
        //}
    }
    return ret.trim();    
};